/**
 * Maps States list into states options for dropdown control
 * @param {[{id: string, name: string}]|undefined} states List of States
 * @returns {[{value: string, label: string}]}
 */
export function mapStatesOptions(states) {
  if (!states) return []

  return states.map(({ id, name }) => ({ value: name, label: name }))
}

/**
 * Maps state to DTO
 * @param {string} firstName
 * @param {string} lastName
 * @param {string} email
 * @param {string} dealershipAddress
 * @param {string} phoneNumber
 * @param {{value: string, label: string}} dealershipState
 * @param {string} dealershipZipCode
 * @param {string} dealershipCity
 * @param {string} dealershipName
 * @returns {{firstName, lastName, email, dealershipAddress, phoneNumber, dealershipState, dealershipZipCode, dealershipCity, dealershipName}}
 */
export function mapStateToDto({
  firstName,
  lastName,
  email,
  dealershipAddress,
  phoneNumber,
  dealershipState,
  dealershipZipCode,
  dealershipCity,
  dealershipName,
}) {
  return {
    firstName,
    lastName,
    email,
    dealershipAddress,
    phoneNumber,
    dealershipState: dealershipState.value,
    dealershipZipCode,
    dealershipCity,
    dealershipName,
  }
}
